/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {
    decorative: {
      description: 'Use a decorative divider to highlight an element. Non-decorative dividers are for clearly identifying separation of content.',
      type: 'variant',
      values: [ true ]
    },
    inverse: { type: 'variant', values: [ true ] },
    weight: { type: 'variant', values: [ 'thick' ] }
  },
  rules: [
    { if: { weight: 'thick' }, tokens: { width: 2 } },
    { if: { decorative: true }, tokens: { color: '#b2b9bf' } },
    { if: { inverse: true }, tokens: { color: '#ffffff' } }
  ],
  tokens: { color: '#676e73', width: 1 }
}
export default theme
